module.exports = __webpack_public_path__ + "static/backsplash-18b0f9bc95ad22a57274dd059e0fd12e.jpg";